import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminAppointments from "@/pages/admin/AdminAppointments";

export const Route = createFileRoute("/admin/appointments")({
  head: () => pageHead("Admin \u2014 Appointments \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminAppointments,
});
